var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_4229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 21.59C16.13 27.25 20.76 31.88 26.43 34.76L30.83 30.35C31.38 29.8 32.17 29.64 32.86 29.86C35.1 30.6 37.51 31 40 31C41.11 31 42 31.89 42 33V40C42 41.11 41.11 42 40 42C21.22 42 6 26.78 6 8C6 6.89 6.9 6 8 6H15C16.11 6 17 6.89 17 8C17 10.49 17.4 12.9 18.14 15.14C18.36 15.83 18.2 16.62 17.65 17.17L13.25 21.59Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_4229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.a922d3ce0a9db9aadbd56e5e18770890.svg";
export { ForwardRef as ReactComponent };